<div class="loader">
    <core-helpers-box-loading [hidden]="version != null && this.file != null"></core-helpers-box-loading>
</div>
<div *ngIf="version != null && this.file != null" class="version-detail-preview-file">
  <!-- version detail -->
  <core-versions-detail-box
    [version]="version"
  ></core-versions-detail-box>
  <!-- file item -->
  <core-files-list-item
    [file]="file"
    [menu]="menu"
    (menuClick)="onMenuClick($event)"
    (iconDownloadClick)="onActionDownloadClick($event)"
  ></core-files-list-item>
  <!-- file preview -->
  <core-pdf-annotations-viewer 
    [file]="file" 
    [urlAnnotationsPrefix]="annotationsSaveUrlPrefix"
    [urlAnnotationsLoadPrefix]="annotationsUrlPrefix"
    [context]="context"
    [annotationsAllowed]="canCreateNotes"
    [user]="notesAllowedUser"
    (refreshSignaturesNeeded)="onRefreshSignaturesNeeded($event)"
    >
  </core-pdf-annotations-viewer>
</div>
